import { type LoggerInterface } from '../types/LoggerTypes';

export const NoLogger: LoggerInterface = {
  log: () => {
    //DO NOTHING
  },
  info: () => {
    //DO NOTHING
  },
  warn: () => {
    //DO NOTHING
  },
  error: () => {
    //DO NOTHING
  },
  debug: () => {
    //DO NOTHING
  },
};
